/* ------------------------------------------ GRYFF BLOG SELECTOR - CHRIS 01.12.2016 ----------------------------------------- */
import HELPER from '@/app/utils/HELPER';
import api from '@/app/endpoints.js';
import { GET } from '@/app/api';
import { checkKeyValid } from '@/app/utils/checkRoleApply.ts';
import { base } from '@/app/editor/sidebar/constant';
import { app } from '@/store';

(function (jQuery) {
  jQuery.gfBlogSelector = function (element, options) {
    const defaults = {
      detectChange: function () {},
    };
    this.settings = {};

    const $element = jQuery(element);
    const _this = this;

    const $cSelector = jQuery(
      '<a id="gf-pick-blog" class="button" href="#"><i class="fa fa-crosshairs" aria-hidden="true"></i> Pick a Blog</a>',
    );
    const _mdBlogSelector = '<div id="md-blog-selector"></div>';
    const _content =
      '<div class="gfBS_search"> <svg class="need_a_name" height="16px" viewbox="0 0 16 16"><path d="M6.57,9.66c-1.68,0-3.05-1.37-3.05-3.06s1.37-3.06,3.05-3.06S9.62,4.9,9.62,6.59S8.26,9.66,6.57,9.66z M14,12.92l-3.68-3.7c0.52-0.75,0.83-1.65,0.83-2.63C11.15,4.06,9.1,2,6.57,2S2,4.06,2,6.59s2.05,4.59,4.57,4.59c1,0,1.92-0.33,2.68-0.88L12.92,14L14,12.92z" /></svg> <input type="text" id="search-blog" name="search-blog" value="" placeholder="Search blogs" /> </div> <div class="gfBS_body"> <div class="blog-list"> <p class="text-center"></p> </div> <div class="search_notfound"> <span class="gfBS_icon_notfound"></span> <span class="text">No Products Found</span> </div> </div> <div class="gfBS_footer"> <button class="btnCancel" class="cancel">Cancel</button> </div>';

    let _blogsData;
    const $activeModal = jQuery(_mdBlogSelector);
    let $blogList;

    /* Editor */
    const $gfLeftSideBar = jQuery('#gfLeftSideBar');
    const $divTopBar = jQuery('#divTopBar');
    const $divContentHidden = jQuery('#divContentHidden');

    /* Iframe */
    const $gfFrame = jQuery('#gfFrame');
    const $gryffBody = $gfFrame.contents().find('body').first();
    const $divContentBk = $gfFrame.contents().find('#divContentBk');

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);

      $element.gfInputField();

      if ($element.next('.gfInputField').next('#gf-pick-blog').length == 0) {
        $element.next('.gfInputField').after($cSelector);
      }
      this.applyEvents();

      const $pid = $element.parents('.columns').siblings().find('#pid');
      $pid.on('value-change', function () {
        $pid.trigger('input-change');
      });
    };

    this.applyEvents = function () {
      $cSelector.off().on('click', function () {
        _this.showBlogSelector();
      });

      $element.off('mousedown').on('mousedown', function () {
        $cSelector.trigger('click');
        return false;
      });
      return false;
    };

    this.showBlogSelector = async function () {
      const crEditID = $gfLeftSideBar.find('#md-settings').data('edittingID');
      if (crEditID.indexOf('-child') !== -1) {
        HELPER.showNotify("Can't change blog", 'error');
        return false;
      }
      $activeModal.appendTo($divContentHidden);

      $activeModal.gfModalNew({
        title: 'Link a blog',
        header: 'noIcon',
        footer: '',
        background: '#F3F5F9',
        width: 580,
        height: 613,
        left: $gfLeftSideBar.children().innerWidth(),
        top: $divTopBar.innerHeight(),
        loading: true,
        onContent: function ($content) {
          $content.html(_content);
        },
      });

      $activeModal.data('gfmodalnew').onShow();

      // Click btn Cancel
      $activeModal
        .find('.gfBS_footer .btnCancel')
        .off('click')
        .on('click', function () {
          $activeModal.remove();
        });

      // update stuffs
      $blogList = $activeModal.find('.blog-list');
      const shop = $gfFrame.data('gfframe').getShopDomain();
      const data = {
        shop: shop,
        limit: 50,
      };

      try {
        const res = await GET(api.getBlogs().url, data);
        const jsonData = res.data;
        if (jsonData && jsonData.blogs && jsonData.blogs.length) {
          _blogsData = jsonData['blogs'];
          const _blogs = jsonData['blogs'];
          let html = '';
          for (let i = 0; i < _blogs.length; i++) {
            html +=
              '<li data-bId="' +
              _blogs[i].id +
              '" data-bHandle="' +
              _blogs[i].handle +
              '" data-bTitle="' +
              _blogs[i].title +
              '">';
            if (_blogs[i].image && _blogs[i].image.src) {
              // Src image small
              const smallSrc = HELPER.getImageSmall(_blogs[i].image.src, {
                width: 40,
                height: 40,
              });
              html += '<div class="gfBS_thumbnail">';
              html += '<img src="' + smallSrc + '" />';
              html += '</div>';
            } else {
              html += '<div class="gfBS_thumbnail">';
              html += '<div class="gfBS_icon_thumbnail"></div>';
              html += '</div>';
            }

            html += '<span>' + _blogs[i].title + '</span>';

            html += '</li>';
          }
          html = '<ul>' + html + '</ul>';

          $blogList.html(html).addClass('optiscroll').optiscroll();
          $activeModal.data('gfmodalnew').offLoading();

          _this.bindBlogEvents();
        } else {
          $activeModal.data('gfmodalnew').onClose();
          HELPER.showNotify('Blogs not found', 'error');
        }
      } catch (err) {
        HELPER.showNotify('There are some errors occurred please try again. 999', 'error');
      }

      let delaySearch;
      let delayAjaxSearch;
      $activeModal
        .find('#search-blog')
        .off('keyup paste')
        .on('keyup paste', function () {
          clearTimeout(delaySearch);
          clearTimeout(delayAjaxSearch);
          let count = 0;
          const input = jQuery(this).val().trim().toLowerCase();
          $activeModal.find('.search_notfound').removeClass('active');

          delaySearch = setTimeout(function () {
            if (input !== '') {
              $blogList.find('ul li').hide();
              const $blog = $blogList.find('ul li');
              for (let i = 0; i < $blog.length; i++) {
                const title = $($blog[i]).find('span').text().toLowerCase();
                if (title.indexOf(input) >= 0) {
                  $($blog[i]).show();
                  count++;
                }
              }
            } else {
              $blogList.find('ul li').show();
            }
          }, 10);

          delayAjaxSearch = setTimeout(function () {
            if (input !== '') {
              _this.searchBlogs(input, count);
            }
          }, 500);
        });

      return false;
    };

    this.bindBlogEvents = function () {
      $blogList
        .find('ul li')
        .off('click')
        .on('click', function () {
          const bTitle = jQuery(this).attr('data-bTitle');
          const bId = jQuery(this).attr('data-bId');
          const bHandle = jQuery(this).attr('data-bHandle');

          const $bId = $element.parents('.columns').siblings().find('#bId');
          const $bHandle = $element.parents('.columns').siblings().find('#bHandle');

          const valueBId = typeof $bId.attr('value') != undefined ? $bId.attr('value') : $bId.attr('default_value');
          const valueBHandle =
            typeof $bHandle.attr('value') != undefined ? $bHandle.attr('value') : $bHandle.attr('default_value');

          if (valueBId !== bId || valueBHandle !== bHandle) {
            // set new blog
            const moduleId = $gfLeftSideBar.find('#md-settings').data('edittingID').replace('m-', '');

            setTimeout(function () {

              if (checkKeyValid("syncBHandleForArticleList")) {
                $element
                .attr('data-value', bTitle)
                .attr('value', bTitle)
                .val(bTitle)
                .trigger('value-change');
              } else {
                $element
                .attr('data-value', bTitle)
                .attr('value', bTitle)
                .val(bTitle)
                .trigger('value-change')
                .trigger('input-change');
              };

              $bHandle.attr('default-value', bHandle).attr('value', bHandle).val(bHandle);
              $bId.attr('default-value', bId).attr('value', bId).val(bId).trigger('input-change');

              $bId.trigger('history-change');
            }, 100);

            let $settings = '';
            let fields = [];

            try {
              const keySettings = HELPER.getKeyDataSetting(base._settings, moduleId);
              $settings = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keySettings);
              fields = jQuery.parseJSON($settings);
            } catch (err) {
              console.log(err.message);
            }
            for (let i = 0; i < fields.length; i++) {
              if (fields[i].name == 'blog') {
                fields[i].default_value = bTitle;
              }
              if (fields[i].name == 'bId') {
                fields[i].default_value = bId;
              }
              if (fields[i].name == 'bHandle') {
                fields[i].default_value = bHandle;
              }
            }
            const keySettings = HELPER.getKeyDataSetting(base._settings, moduleId);
            app.$store.commit('editor/SET_DATA_SETTINGS', {
              id: keySettings,
              value: JSON.stringify(fields),
            });

            _this.settings.detectChange();

            $activeModal.remove();
          } else {
            $activeModal.remove();
          }
          return false;
        });
    };

    this.searchBlogs = async function (s, count) {
      const shop = $gfFrame.data('gfframe').getShopDomain();

      const data = {
        shop: shop,
        s: s,
        limit: 249,
      };
      try {
        const res = await GET(api.searchBlogs().url, data);
        const jsonData = res.data;
        if (!jQuery.isEmptyObject(jsonData)) {
          const _blogs = jsonData['blogs'];
          // Check search !== search off
          for (var i = 0; i < _blogsData.length; i++) {
            for (let j = 0; j < _blogs.length; j++) {
              if (_blogs[j].id == _blogsData[i].id) {
                _blogs.splice(j, 1);
              }
            }
          }
          // push store data
          for (var i = 0; i < _blogs.length; i++) {
            _blogsData.push(_blogs[i]);
          }

          if (_blogs.length > 0) {
            let html = '';
            for (var i = 0; i < _blogs.length; i++) {
              html +=
                '<li data-bid="' +
                _blogs[i].id +
                '" data-bHandle="' +
                _blogs[i].handle +
                '" data-bTitle="' +
                _blogs[i].title +
                '">';

              if (_blogs[i].image && _blogs[i].image.src) {
                // Src image small
                const smallSrc = HELPER.getImageSmall(_blogs[i].image.src, {
                  width: 40,
                  height: 40,
                });
                html += '<div class="gfBS_thumbnail">';
                html += '<img src="' + smallSrc + '" />';
                html += '</div>';
              } else {
                html += '<div class="gfBS_thumbnail">';
                html += '<div class="gfBS_icon_thumbnail"></div>';
                html += '</div>';
              }

              html += '<span>' + _blogs[i].title + '</span>';

              html += '</li>';
            }
            $blogList.find('ul').append(html);
            _this.bindBlogEvents();
          } else {
            if (count == 0) {
              // not found
              $activeModal.find('.search_notfound').addClass('active');
            }
          }
        }
      } catch (error) {
        HELPER.showNotify('There are some errors occurred please try again. 999', 'error');
      }
    };
    this.init();
  };

  jQuery.fn.gfBlogSelector = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfblogselector')) {
        const plugin = new jQuery.gfBlogSelector(this, options);
        jQuery(this).data('gfblogselector', plugin);
      }
    });
  };
})(jQuery);
